import { CommentVisibility } from '@applicant-tracker/enums/comment-visibility.enum';
import { HiringAccessLevelIdsEnum } from '@applicant-tracker/enums/hiring-access-levels.enum';
import { Employee } from '@models/employee/employee.model';
import { ApplicantDiscussion } from '@models/recruiting/applicant-discussion.model';
import { ModelMixin } from '../core/base-generic.model';

export class DiscussionComment extends ModelMixin<DiscussionComment>() {
    protected static _resource = 'applicantTracker/discussionComments';

    protected static _version = 'v2';

    protected static _type = 'discussionComments';

    protected static _serializeAttributes = [
        'atsApplicantDiscussionId',
        'posted_by',
        'visibility',
        'accessLevelId',
        'isPrivate',
        'message',
        'attach',
        'detach',
    ];

    public selected = false;

    get atsApplicantDiscussionId(): number {
        return this._attributes['atsApplicantDiscussionId'];
    }

    set atsApplicantDiscussionId(val: number) {
        this._attributes['atsApplicantDiscussionId'] = val;
    }

    get postedBy(): number {
        return this._attributes['postedBy'];
    }

    set postedBy(val: number) {
        this._attributes['postedBy'] = val;
    }

    get visibility(): CommentVisibility {
        return this._attributes['visibility'];
    }

    set visibility(val: CommentVisibility) {
        this._attributes['visibility'] = val;
    }

    get accessLevelId(): HiringAccessLevelIdsEnum {
        if (this.isPrivate) {
            return HiringAccessLevelIdsEnum.private;
        }

        if (this._attributes['accessLevelId'] === null) {
            return 0;
        }

        return this._attributes['accessLevelId'];
    }

    set accessLevelId(val: HiringAccessLevelIdsEnum) {
        if (val === 0) {
            this._attributes['accessLevelId'] = null;
            return;
        }

        if (val === HiringAccessLevelIdsEnum.private) {
            this._attributes['accessLevelId'] = null;
            this.isPrivate = true;
            return;
        }

        this._attributes['accessLevelId'] = val;
    }

    get isPrivate(): boolean {
        return this._attributes['isPrivate'];
    }

    set isPrivate(val: boolean) {
        this._attributes['isPrivate'] = val;
    }

    get message(): string {
        return this._attributes['message'];
    }

    set message(val: string) {
        this._attributes['message'] = val;
    }

    get applicantDiscussion(): ApplicantDiscussion {
        return this.hasOne(ApplicantDiscussion, 'atsApplicantDiscussionId');
    }

    get author(): Employee {
        return this.hasOne(Employee, 'author');
    }

    get taggedEmployees(): Employee[] {
        return this.hasMany(Employee, 'taggedEmployees');
    }
}
